import {createFileRoute} from '@tanstack/react-router';
import {ConnectBankCallbackPage} from 'features/saved-accounts/pages/ConnectBankCallbackPage';

export const Route = createFileRoute(
  '/_protected/home/service/connect-bank/callback',
)({
  component: ConnectBankCallbackPage,
});
